import React, { Component, Fragment } from "react";
import AUX from "../../../../hoc/Aux_";
import _ from "lodash";
import DatePicker from "react-datepicker";
import moment from "moment";

import Services from "../FacilityDashoardService";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import $ from "jquery";

import { toast } from "react-toastify";
class EditMemberModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MemberId: this.props.MemberId,
      data: [],
      openModal: false,

      obj: null,
    };
    this.cancelModal = this.cancelModal.bind(this);
    this.saveModal = this.saveModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.createOperationObj = this.createOperationObj.bind(this);
    this.dateControl = this.dateControl.bind(this);
    this.handleIsHideChange = this.handleIsHideChange.bind(this);

    this.saveCancelButton = this.saveCancelButton.bind(this);
  }
  componentWillUnmount() {}

  async saveModal() {
    $(".loading").show();
    let obj = this.state.obj;
    if (obj == null) {
      $(".loading").hide();
      toast.error("Invalid Data!");
      return;
    }
    if (!moment(obj.StartDate).isValid() || !moment(obj.EndDate).isValid()) {
      toast.error("Invalid Dates");
      $(".loading").hide();
      return;
    }

    let data = await Services.UpdateOfficerHistoricalPosition(obj);

    if (data) {
      toast.success("position edited successfully!");

      this.props.setReloader();
      this.cancelModal();
    } else {
      $(".loading").hide();
    }
  }
  createOperationObj() {
    let { position } = this.props;

    let obj = null;

    if (position != null) {
      obj = {
        ID: position.id,
        TPMID: position.tpmid,
        MemberId: position.memberID,
        StartDate: position.startDate,
        EndDate: position.endDate,
        isHide: position.isHideOnProfile,
      };
    }
    this.setState({ obj: obj });
  }

  componentDidUpdate(prevProps) {
    if (this.props.openModal && !_.isEmpty(this.props.position)) {
      this.createOperationObj();
      this.setState({
        openModal: this.props.openModal,
      });
      this.openModal();
    }
  }
  componentDidMount() {}

  cancelModal() {
    this.setState({ openModal: false, obj: null });
  }
  openModal() {
    this.props.closeModal();
  }
  saveCancelButton = () => {
    return (
      <Fragment>
        <hr />
        <div className="row pt-3">
          <div className="col-4"></div>
          <div className="col-8">
            <div className="text-right">
              <button
                className="btn btn-danger btn-x-sm btn-sm w-md waves-effect waves-light"
                type="button"
                onClick={this.cancelModal}
              >
                Cancel
              </button>
              <button
                onClick={this.saveModal}
                className="btn btn-success btn-x-sm btn-sm ml-2 w-md waves-effect waves-light"
                type="submit"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  handleIsHideChange = (e) => {
    this.state.obj.isHide = e.target.checked;
    this.setState({ obj: this.state.obj });
  };
  handleChangStartDate = (date) => {
    let { obj } = this.state;
    if (moment(date).isValid()) {
      obj.StartDate = moment(date).format("MM/DD/YYYY");
    } else {
      obj.StartDate = date;
    }
    this.setState({ obj: obj });
  };
  handleChangEndDate = (date) => {
    let { obj } = this.state;
    if (moment(date).isValid()) {
      obj.EndDate = moment(date).format("MM/DD/YYYY");
    } else {
      obj.EndDate = date;
    }

    this.setState({ obj: obj });
  };
  dateControl = () => {
    let obj = this.state.obj;
    return (
      <Fragment>
        <div className="col-lg-12 px-0 row mx-0 mt-4">
          <div class={"md-form form-group mt-0 mb-2 col-6"}>
            <span className="card-subtitle align-self-end pr-1 mb-2 text-secondary">
              Start Date:
            </span>
            <DatePicker
              dateForm="MM/DD/YYYY"
              className="text-dark"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              onChange={this.handleChangStartDate}
              selected={
                obj && obj.StartDate ? moment(obj.StartDate).toDate() : null
              }
              placeholderText={"MM/DD/YYYY"}
            />
          </div>
          <div class={"md-form form-group mt-0 mb-2 col-6"}>
            <span className="card-subtitle align-self-end pr-1 mb-2 text-secondary">
              End Date:
            </span>
            <DatePicker
              dateForm="MM/DD/YYYY"
              className="text-dark"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              onChange={this.handleChangEndDate}
              selected={
                obj && obj.EndDate ? moment(obj.EndDate).toDate() : null
              }
              placeholderText={"MM/DD/YYYY"}
            />
          </div>
        </div>
        <div className="col-12 mt-2">
          <div class="card-text pl-2 py-2 w-100 custom-checkbox">
            <input
              id={"IsHide"}
              name={"IsHide"}
              type="checkbox"
              checked={obj ? obj.isHide : false}
              onChange={this.handleIsHideChange}
              className="custom-control-input pr-2"
            />
            <label className="h6 custom-control-label" for={"IsHide"}>
              Hide on User’s Profile
            </label>
          </div>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <AUX>
        <Modal
          id={"HistoricalPositionUpdate"}
          className="styled-modal"
          isOpen={this.state.openModal}
          size={"md"}
          style={{ zIndex: 1100 }}
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader
            toggle={this.cancelModal}
            className="modal-header text-uppercase bg-secondary py-2"
          >
            Update Position
          </ModalHeader>
          <ModalBody className="modal-body py-2">
            {this.dateControl()}
            {this.saveCancelButton()}
          </ModalBody>
        </Modal>
      </AUX>
    );
  }
}

export default EditMemberModal;
